(() => {
  function init(root) {
    if (root.dataset.tabsReady) return;
    root.dataset.tabsReady = 'true';
    const buttons = [...root.querySelectorAll('[data-home-collection]')];
    const host = root.querySelector('[data-home-track-host]');
    const heading = root.querySelector('[data-home-title]');
    const count = root.querySelector('[data-home-count]');
    const status = root.querySelector('[data-home-status]');
    status.classList.add('visually-hidden');
    const more = root.querySelector('[data-home-more]');
    const fallback = root.querySelector('[data-home-fallback]');
    const cache = new Map();
    let current = buttons.find(b => b.getAttribute('aria-pressed') === 'true'), sequence = 0;
    const initial = host.querySelector('[data-home-feed]');
    if (initial && current) cache.set(current.dataset.homeCollection, initial);
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    function update(feed) {
      count.textContent = feed.dataset.total + ' paintings';
      more.hidden = !feed.dataset.next;
      more.disabled = false;
      fallback.hidden = true;
    }
    async function fetchFeed(url) {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const feed = doc.querySelector('[data-home-feed]');
      if (!feed) throw new Error('Collection unavailable');
      return document.importNode(feed, true);
    }
    buttons.forEach(button => button.addEventListener('click', async () => {
      const token = ++sequence;
      status.classList.add('visually-hidden');
      status.textContent = 'Loading ' + button.textContent.trim().toLowerCase() + '…';
      host.setAttribute('aria-busy', 'true');
      more.disabled = true;
      fallback.hidden = true;
      try {
        let feed = cache.get(button.dataset.homeCollection);
        if (!feed) {
          feed = await fetchFeed(button.dataset.feedUrl);
          cache.set(button.dataset.homeCollection, feed);
        }
        if (token !== sequence) return;
        current = button;
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        host.replaceChildren(feed);
        heading.textContent = button.textContent.trim();
        feed.scrollLeft = 0;
        update(feed);
        status.textContent = heading.textContent + ' loaded.';
      } catch (e) {
        if (token !== sequence) return;
        status.classList.remove('visually-hidden');
        status.textContent = 'This collection could not load. Try again or open the collection.';
        fallback.href = button.dataset.collectionUrl;
        fallback.hidden = false;
        more.disabled = false;
      } finally {
        if (token === sequence) host.setAttribute('aria-busy', 'false');
      }
    }));
    more.addEventListener('click', async () => {
      const token = sequence, feed = host.querySelector('[data-home-feed]');
      if (!feed?.dataset.next || more.disabled) return;
      more.disabled = true;
      status.classList.add('visually-hidden');
      status.textContent = 'Loading more paintings…';
      try {
        const incoming = await fetchFeed(feed.dataset.next);
        if (token !== sequence) return;
        const seen = new Set([...feed.querySelectorAll('.q-card')].map(c => c.href));
        incoming.querySelectorAll('.q-card').forEach(card => { if (!seen.has(card.href)) feed.append(card); });
        feed.dataset.next = incoming.dataset.next || '';
        update(feed);
        status.textContent = 'More paintings loaded.';
        feed.scrollBy({ left: feed.clientWidth * .75, behavior: motion() });
      } catch (e) {
        if (token === sequence) { status.classList.remove('visually-hidden'); status.textContent = 'Could not load more paintings. Please try again.'; more.disabled = false; }
      }
    });
    root.querySelectorAll('[data-home-direction]').forEach(button => button.addEventListener('click', () => {
      const track = host.querySelector('[data-home-feed]'), card = track?.querySelector('.q-card');
      if (!card) return;
      const direction = Number(button.dataset.homeDirection);
      if (direction > 0 && track.scrollLeft + track.clientWidth >= track.scrollWidth - 8 && track.dataset.next) { more.click(); return; }
      track.scrollBy({ left: (card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0)) * direction, behavior: motion() });
    }));
    if (initial) update(initial);
  }
  document.querySelectorAll('[data-home-browser]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-home-browser]').forEach(init));
})();
